var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-tooltip",style:({
    '--border-radius': _vm.borderRadius,
    top: _vm.options.top + 'px',
    left: _vm.options.left + 'px',
    right: _vm.options.right + 'px',
  }),on:{"click":function($event){return $event.stopPropagation()}}},[_vm._t("default",function(){return [_c('div',{staticClass:"tooltip-content"},[_vm._v(" "+_vm._s(_vm.options.text)+" ")]),_c('div',{staticClass:"button-wrapper"},[_c('BaseButton',{attrs:{"type":"quin"},on:{"click":_vm.hideCallback}},[_vm._v(_vm._s(_vm.options.buttonText))])],1)]},{"options":_vm.options,"hideCallback":_vm.hideCallback})],2)}
var staticRenderFns = []

export { render, staticRenderFns }